var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibility = function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F54",
    d: "M6.25 2.738q-.52 0-.894-.404-.373-.402-.373-.965c0-.563.124-.697.373-.966Q5.729 0 6.25 0c.521 0 .645.134.894.403q.373.403.373.966c0 .563-.124.697-.373.965a1.18 1.18 0 0 1-.894.403M4.375 15V5.006H0V3.881h12.5v1.125H8.125V15H7.083v-4.875H5.417V15z"
  })));
};
export default SvgAccessibility;